import React, {useEffect, useState} from "react";
import axios from "config/axiosConfig";
import {Link, useLocation, useNavigate, useSearchParams} from "react-router-dom";
import {formatBusinessNumber, formatCurrency, formatDate} from "page/util/helpers";

import DatePicker from "react-datepicker";
import dateFormat, { masks } from "dateformat";
import 'react-datepicker/dist/react-datepicker.css';
import {Pagination} from "../../util/Pagination";

export default function Detail() {
    const [searchParams, setSearchParams] = useSearchParams();
    const [paymentHistoryPaginationDto, setPaymentHistoryPaginationDto] = useState();
    const [paymentHistories, setPaymentHistories] = useState();
    const [paymentCards, setPaymentCards] = useState([]);

    const [content, setContent] = useState();

    const [handleStartDate, setHandleStartDate] = useState();
    const [handleEndDate, setHandleEndDate] = useState();
    const [handleMembership, setHandleMembership] = useState();
    const [handleNationalManagementNo, setHandleNationalManagementNo] = useState();
    const [handleMemo, setHandleMemo] = useState("");

    const navigate = useNavigate();
    const location = useLocation();

    const queryParams = new URLSearchParams(location.search); // 쿼리 파라미터 추출
    const bizId = queryParams.get("bizId");

    const page = searchParams.get('page') || "1";

    const requestData = (e) => {
        axios.get(`/admin/bizs/${bizId}`)
            .then((res) => {
                setContent(res.data);
                setHandleStartDate(res.data.startDate);
                setHandleEndDate(res.data.endDate);
                setHandleMembership(res.data.membership);
                setHandleNationalManagementNo(res.data.nationalManagementNo);
                setHandleMemo(res.data.memo || "");
            });
    }

    const requestPaymentHistories = (e) => {
        const params = {};
        params.page = page;
        params.pageSize = 10;
        params.bizId = bizId;

        axios.get(`/admin/payment-histories`, { params: params })
            .then((res) => {
                setPaymentHistoryPaginationDto(res.data);
                setPaymentHistories(res.data.content);
            });
    }

    const requestPaymentCards = (bizNo) => {
        axios.get(`/admin/payments/cards`, { params: { bizNo: bizNo } })
            .then((res) => {
                setPaymentCards(res.data);
            })
            .catch(() => {
                setPaymentCards([]);
            });
    }

    const handleSetMainCard = (cardId) => {
        if (!content?.number) {
            return;
        }
        axios.put(`/admin/payments/cards/main`, null, {
            params: {
                bizNo: content.number,
                cardId: cardId
            }
        }).then(() => {
            requestPaymentCards(content.number);
            window.toastr.success('대표카드로 설정되었습니다.');
        });
    }

    const maskCardNumber = (number) => {
        if (!number) {
            return "-";
        }
        const clean = number.replace(/\D/g, '');
        if (clean.length <= 4) {
            return clean;
        }
        return clean.replace(/\d(?=\d{4})/g, '*').replace(/(.{4})/g, '$1 ').trim();
    }

    const requestUpdate = (e) => {
        if (handleMembership === "BUSINESS" && handleStartDate >= handleEndDate) {
            alert("구독 기간을 확인해주세요.");
            return;
        }
        if (handleMembership === "BUSINESS" && (handleStartDate === null || handleEndDate === null)) {
            alert("구독 기간을 확인해주세요.");
            return;
        }

        const params = new FormData();
        params.append("membership", handleMembership);
        if (handleMembership === "BUSINESS") {
            params.append("startDate", handleStartDate);
            params.append("endDate", handleEndDate);
        }

        params.append("nationalManagementNo", handleNationalManagementNo);

        axios.put(`/admin/bizs/${bizId}`, params, {
            headers: {'content-type': 'application/x-www-form-urlencoded'}
        })
        .then((res) => {
            window.toastr.success('수정되었습니다.');
            window.location.reload();
        });
    }

    const requestMemoUpdate = () => {
        const params = new FormData();
        params.append("memo", handleMemo);

        axios.put(`/admin/bizs/${bizId}/memo`, params, {
            headers: {'content-type': 'application/x-www-form-urlencoded'}
        })
        .then((res) => {
            window.toastr.success('메모가 저장되었습니다.');
        });
    }

    const displayMembershipStatus = (membershipStatus) => {
        switch (membershipStatus) {
            case "UNSUBSCRIBE": return <span style={{color: "gray"}}>미구독</span>
            case "SUBSCRIBE": return <span style={{color: "blue"}}>구독중</span>
            case "SUBSCRIBE_HOLD": return <span style={{color: "red"}}>구독보류</span>
            case "SUBSCRIBE_CANCEL": return <span style={{color: "red"}}>구독취소요청중</span>
            default: return <span style={{color: "gray"}}>미구독</span>
        }
    }

    const getNextPaymentDate = () => {
        if (!handleEndDate) return null;

        const endDateObj = new Date(handleEndDate);
        const nextDate = new Date(endDateObj);
        nextDate.setDate(endDateObj.getDate() + 1);

        return dateFormat(nextDate, 'yyyy-mm-dd');
    };

    const displayStatus = (status, reason) => {
        switch (status) {
            case "paid": return <span>결제완료</span>
            case "ready": return "준비됨"
            case "failed": return <span style={{color: 'red'}}>결제실패({reason})</span>
            case "cancelled": return "취소"
            case "partialCancelled": return "부분취소"
            case "expired": return "만료됨"
            case "subscribeCancel": return "구독취소"
            case "noCard": return <span style={{color: 'red'}}>결제실패(카드없음)</span>
            default: return status
        }
    }

    const setPage = (page) => {
        searchParams.set('page', page);
        setSearchParams(searchParams, {replace: true})
    }

    useEffect(() => {
        requestData();
    }, []);

    useEffect(() => {
        if (content?.number) {
            requestPaymentCards(content.number);
        }
    }, [content]);

    useEffect(() => {
        requestPaymentHistories();
    }, [page]);

    return (
        <div className="App">
            <div className="wrapper">
                <div className="content-wrapper" style={{marginLeft: '0px'}}>
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active">사업장관리 > 상세</li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">

                                    <div className="invoice p-3 mb-3">
                                        <div className="row">
                                            <div className="col-12">
                                                <p className="lead">비즈정보</p>
                                                <div className="table-responsive">
                                                    <table className="table">
                                                        {
                                                            content && (
                                                                <tbody>
                                                                <tr>
                                                                    <th style={{width: "120px"}}>SEQ</th>
                                                                    <td>{content.id}</td>
                                                                    <th style={{width: "120px"}}>대표자명</th>
                                                                    <td>{content.ceoName}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>사업장명</th>
                                                                    <td>{content.name}</td>
                                                                    <th>사업장번호</th>
                                                                    <td>{formatBusinessNumber(content.number)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>사업장주소</th>
                                                                    <td></td>
                                                                    <th>오픈일</th>
                                                                    <td>{content.openDate}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>구독시작일</th>
                                                                    <td>
                                                                        <DatePicker
                                                                            dateFormat="yyyy-MM-dd"
                                                                            dateFormatCalendar="yyyy년 MM월"
                                                                            locale="ko"
                                                                            selected={handleStartDate}
                                                                            onChange={date => {
                                                                                setHandleStartDate(dateFormat(date, 'yyyy-mm-dd'))
                                                                            }}
                                                                        />
                                                                    </td>
                                                                    <th>구독만료일</th>
                                                                    <td>
                                                                        <DatePicker
                                                                            dateFormat="yyyy-MM-dd"
                                                                            dateFormatCalendar="yyyy년 MM월"
                                                                            locale="ko"
                                                                            selected={handleEndDate}
                                                                            onChange={date => {
                                                                                setHandleEndDate(dateFormat(date, 'yyyy-mm-dd'))
                                                                            }}
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>다음결제일</th>
                                                                    <td>{getNextPaymentDate() ?? '-'}</td>
                                                                    <th>멤버십</th>
                                                                    <td>
                                                                        <select className="form-control"
                                                                                style={{width: '120px', marginRight: '20px'}}
                                                                                onChange={e => {
                                                                                    setHandleMembership(e.target.value)
                                                                                }}
                                                                                value={handleMembership}>
                                                                            <option value="BASIC">BASIC</option>
                                                                            <option value="BUSINESS">BUSINESS</option>
                                                                        </select>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <th>멤버십상태</th>
                                                                    <td>{displayMembershipStatus(content.membershipStatus)}</td>
                                                                    <th>가입일</th>
                                                                    <td>{formatDate(content.createdAt)}</td>
                                                                </tr>
                                                                <tr>
                                                                    <th>EDI 관리번호</th>
                                                                    <td colSpan={3}>
                                                                        <input type="text" className="form-control" id="searchText" maxLength={11}
                                                                               onChange={e => {
                                                                                   const onlyNumbers = e.target.value.replace(/[^0-9]/g, '');
                                                                                   setHandleNationalManagementNo(onlyNumbers);
                                                                               }}
                                                                               value={handleNationalManagementNo}
                                                                               placeholder="관리번호 11글자입력"
                                                                        />
                                                                    </td>
                                                                </tr>
                                                                {
                                                                    content.users.length > 0 && (
                                                                        <tr>
                                                                            <th>회원정보</th>
                                                                            <td colSpan={3}>
                                                                                <table>
                                                                                    <thead>
                                                                                    <tr>
                                                                                        <td style={{borderTop: 'none'}}>이름</td>
                                                                                        <td style={{borderTop: 'none'}}>이메일</td>
                                                                                        <td style={{borderTop: 'none'}}>extId</td>
                                                                                        <td style={{borderTop: 'none'}}>상세보기</td>
                                                                                    </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                    {
                                                                                        content.users && content.users.map( item =>
                                                                                            <tr>
                                                                                                <td>{item.name}</td>
                                                                                                <td>{item.email}</td>
                                                                                                <td>{item.extId}</td>
                                                                                                <td>
                                                                                                    <button type="button"
                                                                                                            className="btn btn-outline-info">
                                                                                                        <Link to={`/page/user/member/detail?userId=${item.id}`} target="_blank">보기</Link>
                                                                                                    </button>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    }
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }
                                                                {
                                                                    content.userDrops.length > 0 && (
                                                                        <tr>
                                                                            <th>탈퇴정보</th>
                                                                            <td colSpan={3}>
                                                                                <table>
                                                                                    <thead>
                                                                                    <tr>
                                                                                        <td style={{borderTop: 'none'}}>이름</td>
                                                                                        <td style={{borderTop: 'none'}}>이메일</td>
                                                                                        <td style={{borderTop: 'none'}}>extId</td>
                                                                                        <td style={{borderTop: 'none'}}>상세보기</td>
                                                                                    </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                    {
                                                                                        content.userDrops && content.userDrops.map( item =>
                                                                                            <tr>
                                                                                                <td>{item.name}</td>
                                                                                                <td>{item.email}</td>
                                                                                                <td>{item.extId}</td>
                                                                                                <td>
                                                                                                    <button type="button"
                                                                                                            className="btn btn-outline-info">
                                                                                                        <Link to={`/page/user/drop/detail?userDropId=${item.id}`} target="_blank">보기</Link>
                                                                                                    </button>
                                                                                                </td>
                                                                                            </tr>
                                                                                        )
                                                                                    }
                                                                                    </tbody>
                                                                                </table>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                }
                                                                </tbody>
                                                            )
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                            {/* /.col */}
                                        </div>
                                    </div>

                                    <div className="row" style={{marginTop: '30px', marginBottom: '10px'}}>
                                        <div style={{margin: "0 auto"}}>
                                            <button type="button"
                                                    className="btn btn-outline-danger"
                                                    onClick={requestUpdate}>
                                                수정
                                            </button>
                                            <button type="button" className="btn btn-outline-dark"
                                                    style={{marginLeft: '10px'}}
                                                    onClick={e => navigate(-1)}>
                                                목록
                                            </button>
                                        </div>
                                    </div>

                                    <div className="row" style={{marginTop: '20px'}}>
                                        <div className="col-12">
                                            <div className="card">
                                                <div className="card-header">
                                                    <h3 className="card-title">메모</h3>
                                                </div>
                                                <div className="card-body">
                                                    <textarea
                                                        className="form-control"
                                                        rows="5"
                                                        placeholder="메모를 입력하세요..."
                                                        value={handleMemo}
                                                        onChange={(e) => setHandleMemo(e.target.value)}
                                                    ></textarea>
                                                    <div style={{marginTop: '10px', textAlign: 'right'}}>
                                                        <button type="button" className="btn btn-primary" onClick={requestMemoUpdate}>
                                                            메모 저장
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </section>


                    <section className="content" style={{marginTop: '32px'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <p className="lead" style={{marginLeft: '20px'}}>결제카드 목록</p>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>카드명</th>
                                                    <th>카드번호</th>
                                                    <th>등록일</th>
                                                    <th>대표카드</th>
                                                    <th>동작</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    paymentCards.length > 0 ? paymentCards.map(item => (
                                                        <tr key={item.id}>
                                                            <td>{item.id}</td>
                                                            <td>{item.cardName}</td>
                                                            <td>{maskCardNumber(item.cardNumber)}</td>
                                                            <td>{formatDate(item.createdAt)}</td>
                                                            <td>
                                                                {
                                                                    item.isMain ?
                                                                        <span className="badge badge-success">대표카드</span>
                                                                        :
                                                                        <span>-</span>
                                                                }
                                                            </td>
                                                            <td>
                                                                {
                                                                    item.isMain ? (
                                                                        <button type="button"
                                                                                className="btn btn-outline-secondary btn-sm"
                                                                                disabled>
                                                                            대표카드
                                                                        </button>
                                                                    ) : (
                                                                        <button type="button"
                                                                                className="btn btn-outline-primary btn-sm"
                                                                                onClick={() => handleSetMainCard(item.id)}>
                                                                            대표카드로 설정
                                                                        </button>
                                                                    )
                                                                }
                                                            </td>
                                                        </tr>
                                                    )) : (
                                                        <tr>
                                                            <td colSpan={6}>등록된 카드가 없습니다.</td>
                                                        </tr>
                                                    )
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="content" style={{marginTop: '64px'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">

                                        <div className="card-body table-responsive p-0" style={{marginTop: '20px'}}>
                                            <p className="lead" style={{marginLeft: '20px'}}>결제이력</p>
                                            <table className="table table-hover text-nowrap"
                                                   style={{textAlign: "center"}}>
                                                <thead>
                                                <tr>
                                                    <th>SEQ</th>
                                                    <th>사업장명</th>
                                                    <th>사업자번호</th>
                                                    <th>상품</th>
                                                    <th>결제금액</th>
                                                    <th>주문상태</th>
                                                    <th>사용기간</th>
                                                    <th>결제일</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                {
                                                    paymentHistories && paymentHistories.map(item => {
                                                        return (
                                                            <tr key={item.id}>
                                                                <td>{item.id}</td>
                                                                <td>{item.bizName}</td>
                                                                <td>{formatBusinessNumber(item.bizNo)}</td>
                                                                <td>{item.goodsName}</td>
                                                                <td>{formatCurrency(item.amount)}</td>
                                                                <td>{displayStatus(item.status, item.resultMessage)}</td>
                                                                <td>{item.membershipStartDate} ~ {item.membershipEndDate}</td>
                                                                <td>{formatDate(item.createdAt)}</td>
                                                            </tr>
                                                        )
                                                    })
                                                }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {
                            paymentHistoryPaginationDto && <Pagination pager={paymentHistoryPaginationDto} setPage={setPage}/>
                        }

                    </section>

                </div>
            </div>
        </div>
    );
}
